// @ts-nocheck
(function () {
  if (window.SwipePadsScrollVideo) return;

  var SELECTOR = '[data-scroll-video]';
  var DEFAULT_OFFSET = 0;
  // 0 = map the full video onto the scroll travel (auto behaviour).
  var DEFAULT_PX_PER_SECOND = 0;
  // Legacy attribute support: old sections emitted "pixels per frame" assuming
  // a 30fps video. Convert to px-per-second so both attribute generations work.
  var LEGACY_ASSUMED_FPS = 30;
  // Roughly one frame at 30fps — avoids seeks for sub-frame target jitter.
  // Seek dispatch is otherwise paced by completion: a new seek starts only
  // once the previous one has finished, so the rate self-tunes to what the
  // decoder can sustain (display-rate on fast devices, slower on weak ones)
  // without ever queueing a backlog.
  var MIN_SEEK_DELTA = 0.033;
  // Safety net for the seek scheduler: 'seeked' is the primary release signal,
  // but some browsers skip it when the target rounds to the displayed frame.
  // 120ms is long enough that a real seek (~30-80ms) always completes first,
  // yet short enough that a truly stuck seek recovers quickly.
  var SEEK_RELEASE_TIMEOUT_MS = 120;
  var END_CAP = 0.05;
  // Start fetching video data when the section is within three viewports of
  // the screen — enough lead time for slow connections to buffer the clip
  // before the user reaches it.
  var PRELOAD_ROOT_MARGIN = '300%';
  // Keep seek targets this far inside the buffered range, so we never park
  // the decoder right at the download edge where it would stall.
  var BUFFER_EDGE_MARGIN = 0.1;
  var videos = [];
  var rafActive = false;
  var visibilityObserver = null;
  var preloadObserver = null;

  function getOffset(video) {
    var raw = video.getAttribute('data-scroll-video-offset');
    var parsed = parseFloat(raw);
    return isFinite(parsed) ? parsed : DEFAULT_OFFSET;
  }

  // How many pixels of scroll advance the video by one second of playback.
  // Reads the current px-per-second attribute, falling back to the legacy
  // px-per-frame attribute (converted via the old 30fps assumption).
  function getPxPerSecond(video) {
    var raw = video.getAttribute('data-scroll-video-px-per-second');
    var parsed = parseFloat(raw);
    if (isFinite(parsed) && parsed > 0) return parsed;

    var legacyRaw = video.getAttribute('data-scroll-video-px-per-frame');
    var legacyParsed = parseFloat(legacyRaw);
    if (isFinite(legacyParsed) && legacyParsed > 0) {
      return legacyParsed * LEGACY_ASSUMED_FPS;
    }

    return DEFAULT_PX_PER_SECOND;
  }

  // Mute + inline + no autoplay/loop: we drive currentTime from scroll position.
  function prepareVideo(video) {
    if (video.dataset.scrollVideoPrepared === 'true') return;
    video.dataset.scrollVideoPrepared = 'true';

    video.pause();
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.preload = 'auto';
    video.removeAttribute('autoplay');
    video.loop = false;

    function primeFirstFrame() {
      if (video.dataset.scrollVideoPrimed === 'true') return;
      if (video.readyState < 1) return;

      video.dataset.scrollVideoPrimed = 'true';
      video.removeEventListener('loadeddata', primeFirstFrame);
      video.removeEventListener('loadedmetadata', primeFirstFrame);

      try {
        // A hair past zero, not zero: iOS Safari paints no frame for a video
        // that has never played, and currentTime = 0 on a fresh element is a
        // no-op that schedules no seek. The epsilon forces a real seek whose
        // completion decodes and displays the first frame (still frame 0).
        video.currentTime = 0.001;
      } catch (err) {
        // Metadata can still be settling on mobile browsers.
      }
    }

    video.addEventListener('loadeddata', primeFirstFrame);
    video.addEventListener('loadedmetadata', primeFirstFrame);

    // iOS Safari ignores preload and buffers media lazily: every scroll seek
    // past the small initial chunk stalls on a network round-trip, and in Low
    // Power Mode the element may not load anything at all without a user
    // gesture. Downloading the clip ourselves and swapping it in as a blob
    // sidesteps both — seeks then run against local data only. fetch() is not
    // subject to the media loading/gesture policies, and the clip is small
    // (scrub sources are a few MB by design).
    var src = video.currentSrc || video.src;
    if (src && window.fetch && window.URL && URL.createObjectURL) {
      fetch(src, { mode: 'cors' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.blob();
        })
        .then(function (blob) {
          video.src = URL.createObjectURL(blob);
          video.load();
        })
        .catch(function () {
          // Network/CORS failure: keep the original src and fall back to the
          // browser's own loading, as before the blob path existed.
          if (video.readyState >= 1) {
            primeFirstFrame();
          } else {
            video.load();
          }
        });
    } else if (video.readyState >= 1) {
      primeFirstFrame();
    } else {
      video.load();
    }
  }

  // Backstop for iOS Low Power Mode: even with a local blob the decoder can
  // stay locked until a user gesture. The first touch runs a muted
  // play()+pause() over every scroll video, which unlocks programmatic
  // seeking for the rest of the page's life.
  function unlockVideo(video) {
    if (video.readyState === 0) {
      try { video.load(); } catch (err) { /* ignore */ }
    }
    var played;
    try {
      played = video.play();
    } catch (err) {
      return;
    }
    if (played && played.then) {
      played.then(function () { video.pause(); }).catch(function () {});
    } else {
      video.pause();
    }
  }

  var gestureUnlocked = false;
  function onFirstGesture() {
    if (gestureUnlocked) return;
    gestureUnlocked = true;
    document.removeEventListener('touchstart', onFirstGesture);
    for (var i = 0; i < videos.length; i += 1) {
      unlockVideo(videos[i].video);
    }
  }
  document.addEventListener('touchstart', onFirstGesture, { passive: true });

  // Maps the video's position in the viewport to a 0..1 progress value.
  // progress 0 -> video top is `offset` px into the viewport from the bottom (playback start).
  // progress 1 -> video has fully exited the top of the viewport (playback end).
  function getProgress(video, rect) {
    var viewportHeight = window.innerHeight;
    var offset = getOffset(video);

    var startY = viewportHeight - offset;
    var endY = -rect.height;
    var travel = startY - endY;

    if (travel <= 0) return 0;

    return Math.max(0, Math.min(1, (startY - rect.top) / travel));
  }

  // Pixels the video has been scrolled past its playback-start point.
  // Mirrors getProgress() but returns the raw pixel distance instead of a
  // 0..1 ratio, so callers can convert it to seconds via pxPerSecond.
  function getScrolledPixels(video, rect) {
    var viewportHeight = window.innerHeight;
    var offset = getOffset(video);

    var startY = viewportHeight - offset;
    return Math.max(0, startY - rect.top);
  }

  // Total scroll distance from playback start until the video fully exits the
  // top of the viewport. The completion clamp uses this to guarantee the video
  // reaches its last frame within the available travel on any viewport.
  function getTravel(video, rect) {
    var viewportHeight = window.innerHeight;
    var offset = getOffset(video);
    return viewportHeight - offset + rect.height;
  }

  function clampTime(targetTime, duration) {
    if (!duration || !isFinite(duration)) return targetTime;
    return Math.max(0, Math.min(targetTime, duration - END_CAP));
  }

  // On slow connections the scroll position can outrun the progressive
  // download. Clamping the seek target to the buffered range makes the video
  // smoothly chase the download edge instead of freezing on one frame and
  // jumping ahead when data finally arrives.
  //
  // Only clamp while the browser is actively fetching (NETWORK_LOADING).
  // iOS Safari buffers lazily and goes idle after a small initial chunk —
  // there, more data is only ever fetched when a seek lands beyond the
  // buffered edge, so clamping to the buffer would deadlock the video near
  // its first frames. Passing the raw target lets the seek itself trigger
  // the fetch.
  function clampToBuffered(targetTime, video) {
    if (video.networkState !== 2 /* NETWORK_LOADING */) return targetTime;

    var buffered = video.buffered;
    if (!buffered || !buffered.length) return targetTime;

    var bufferedEnd = buffered.end(buffered.length - 1);
    if (bufferedEnd >= video.duration - END_CAP) return targetTime;

    return Math.min(targetTime, Math.max(0, bufferedEnd - BUFFER_EDGE_MARGIN));
  }

  // Seek scheduler: keeps at most one seek in flight per video and always
  // applies the most recent target once the previous seek completes. This
  // is what stops the decoder from being flooded with conflicting seeks when
  // the scroll speed or direction changes quickly.
  function createSeekScheduler(video) {
    var seekInProgress = false;
    var pendingTarget = null;
    var releaseTimer = null;
    var seekedHandler = null;

    function release() {
      // Guard against double-release (seeked + timeout both firing).
      if (!seekInProgress) return;
      seekInProgress = false;

      if (releaseTimer) {
        window.clearTimeout(releaseTimer);
        releaseTimer = null;
      }
      if (seekedHandler) {
        video.removeEventListener('seeked', seekedHandler);
        seekedHandler = null;
      }

      if (pendingTarget === null) return;
      var nextTarget = pendingTarget;
      pendingTarget = null;
      // Same delta gate as request(): without it, a pending target equal to
      // the current frame would seek anyway and re-arm itself off the next
      // rAF tick — a perpetual no-op seek loop that burns CPU while idle.
      if (Math.abs(video.currentTime - nextTarget) < MIN_SEEK_DELTA) return;
      applySeek(nextTarget);
    }

    function applySeek(targetTime) {
      seekInProgress = true;

      // 'seeked' is the reliable signal that a seek on a paused video has
      // finished decoding and the new frame is ready to display.
      seekedHandler = function () { release(); };
      video.addEventListener('seeked', seekedHandler);

      // Safety net: some browsers don't fire 'seeked' when the target rounds
      // to the currently displayed frame, or if the seek is coalesced away.
      releaseTimer = window.setTimeout(release, SEEK_RELEASE_TIMEOUT_MS);

      try {
        video.currentTime = targetTime;
      } catch (err) {
        // Some browsers briefly reject seeks while metadata is settling.
        release();
      }
    }

    return {
      request: function (targetTime) {
        if (video.readyState < 1) return;

        if (seekInProgress) {
          // Coalesce: remember only the latest target so direction changes
          // don't queue a backlog of stale seeks.
          pendingTarget = targetTime;
          return;
        }

        if (Math.abs(video.currentTime - targetTime) < MIN_SEEK_DELTA) return;

        applySeek(targetTime);
      }
    };
  }

  function update(state) {
    var video = state.video;
    if (!video.isConnected) return;
    if (!state.visible) return;
    if (!video.duration || !isFinite(video.duration)) return;

    var rect = video.getBoundingClientRect();
    var pxPerSecond = getPxPerSecond(video);
    var targetTime;
    if (pxPerSecond > 0) {
      // Completion clamp: never let the configured pace be slower than what
      // the available scroll travel allows, so the video always reaches its
      // last frame before the section leaves the viewport — on short mobile
      // viewports this speeds playback up instead of cutting it off.
      var travel = getTravel(video, rect);
      var maxPxPerSecond = travel / video.duration;
      var effectivePxPerSecond = Math.min(pxPerSecond, maxPxPerSecond);

      var scrolledPx = getScrolledPixels(video, rect);
      targetTime = scrolledPx / effectivePxPerSecond;
    } else {
      var progress = getProgress(video, rect);
      targetTime = progress * video.duration;
    }

    targetTime = clampTime(targetTime, video.duration);
    state.scheduler.request(clampToBuffered(targetTime, video));
  }

  function anyVisible() {
    for (var i = 0; i < videos.length; i += 1) {
      if (videos[i].visible) return true;
    }
    return false;
  }

  function onFrame() {
    if (!anyVisible()) {
      // Park the loop while no scroll video is on screen; the visibility
      // observer restarts it the moment one scrolls back in.
      rafActive = false;
      return;
    }

    for (var i = 0; i < videos.length; i += 1) {
      update(videos[i]);
    }

    window.requestAnimationFrame(onFrame);
  }

  function startLoop() {
    if (rafActive) return;
    rafActive = true;
    window.requestAnimationFrame(onFrame);
  }

  function findState(node) {
    for (var i = 0; i < videos.length; i += 1) {
      if (videos[i].video === node) return videos[i];
    }
    return null;
  }

  function setupObservers() {
    if (visibilityObserver) visibilityObserver.disconnect();
    if (preloadObserver) preloadObserver.disconnect();

    visibilityObserver = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        var state = findState(entries[i].target);
        if (!state) continue;
        state.visible = entries[i].isIntersecting;
      }
      if (anyVisible()) startLoop();
    });

    // Kick off the (potentially multi-MB) video download one viewport ahead
    // of the section instead of on page load.
    preloadObserver = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        if (!entries[i].isIntersecting) continue;
        prepareVideo(entries[i].target);
        preloadObserver.unobserve(entries[i].target);
      }
    }, { rootMargin: PRELOAD_ROOT_MARGIN });

    for (var i = 0; i < videos.length; i += 1) {
      visibilityObserver.observe(videos[i].video);
      preloadObserver.observe(videos[i].video);
    }
  }

  function init() {
    videos = [];

    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (!(node instanceof HTMLVideoElement)) continue;

      // Honour reduced-motion: leave the video on its first frame.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        node.pause();
        continue;
      }

      videos.push({
        video: node,
        scheduler: createSeekScheduler(node),
        visible: false
      });
    }

    if (!videos.length) return;

    if ('IntersectionObserver' in window) {
      setupObservers();
    } else {
      // Ancient fallback: behave like before — load immediately, always update.
      for (var j = 0; j < videos.length; j += 1) {
        videos[j].visible = true;
        prepareVideo(videos[j].video);
      }
      startLoop();
    }
  }

  window.SwipePadsScrollVideo = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
